import {isArray} from 'lodash';
import React, {memo, useEffect, useRef} from 'react';
import NotificationSystem from 'react-notification-system';
import {useSelector} from 'react-redux';
import {RootState} from '~/redux/root-reducer';
import {Col, UiBox, UiContainer, UiText} from '~/components/elements';
import {use100vh} from 'react-div-100vh';

interface Props {
  children: React.ReactNode;
}

const BaseLayout = ({children}: Props) => {
  const notificationSystem = useRef(null);
  const {error, success} = useSelector((state: RootState) => state.ui.messages);
  const height = use100vh();

  useEffect(() => {
    if (error) {
      const notification = notificationSystem.current;
      if (notification) {
        if (isArray(error)) {
          // @ts-ignore
          notification.addNotification({
            title: 'Validation error!',
            level: 'error',
            position: 'tc',
            autoDismiss: 5,
            children: (
              <div>
                {error.map(e => (
                  <p key={e}>{e}</p>
                ))}
              </div>
            ),
          });
        } else {
          // @ts-ignore
          notification.addNotification({
            title: 'Oops, something went wrong!',
            message: error,
            level: 'error',
            position: 'tc',
            autoDismiss: 5,
          });
        }
      }
    }
  }, [error]);

  useEffect(() => {
    if (success) {
      const notification = notificationSystem.current;
      if (notification) {
        // @ts-ignore
        notification.addNotification({
          title: 'Success!',
          message: success,
          level: 'success',
          position: 'tc',
          autoDismiss: 5,
        });
      }
    }
  }, [success]);

  return (
    <UiBox height="100vh" position="relative" m="0 auto">
      <Col h="100%">
        <NotificationSystem ref={notificationSystem} style={notifOverrideStyle} />
        <Col flexGrow={1}>{children}</Col>
      </Col>
    </UiBox>
  );
};

const notifOverrideStyle = {
  Containers: {
    DefaultStyle: {
      zIndex: 99999,
    },
  },
};

export default memo(BaseLayout);
